<div>
    <div class="row">
        <!-- Area -->
        <div class="form-group w-100 col-12">
            <label>{{masterBusinessLabel.Area}}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text px-3 py-2">
                        <svg-icon class="svg_icon16x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_3/area.svg"></svg-icon>
                    </span>
                </div>
                <input type="text" class="form-control" [value]="shiftAllInfo?.area?.area_name" disabled />
            </div>
        </div>
    </div>
    <div class="row">
        <!-- Location -->
        <div class="form-group w-100 col-sm-6">
            <label>{{masterBusinessLabel.Location}}</label>
            <div class="input-group" placement="top" [ngbTooltip]="shiftAllInfo?.location?.location_name">
                <div class="input-group-prepend">
                    <span class="input-group-text px-3 py-2">
                        <svg-icon class="svg_icon16x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_3/location.svg"></svg-icon>
                    </span>
                </div>
                <input type="text" class="form-control" [value]="shiftAllInfo?.location?.location_name" disabled />
            </div>
        </div>
        <!-- Client -->
        <div class="form-group w-100 col-sm-6">
            <label>{{masterBusinessLabel.Client}}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text px-3 py-2">
                        <svg-icon class="svg_icon16x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_3/client.svg"></svg-icon>
                    </span>
                </div>
                <input type="text" class="form-control" [value]="shiftAllInfo.client?.client_name" disabled />
            </div>
        </div>
    </div>
    <div class="row" *ngIf="showDateDetails">
        <!-- Start Date & Time -->
        <div class="form-group w-100 col-sm-12">
            <label>Start Date & Time</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text px-3 py-2">
                        <!-- <img src="../assets/media/icons/png/shift-details/StartDate&Time.png" alt="Client"
                            height="20" /> -->
                            <svg-icon class="svg_icon16x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/start_date_&_time.svg"></svg-icon>
                    </span>
                </div>
                <input type="text" class="form-control" [value]="shiftDetails?.shiftStartDate | TimezoneDateTime"
                    disabled />
                <!-- <textarea rows="2" class="form-control"
                  disabled>{{shiftDetails?.shiftStartDate | TimezoneDateTime}}</textarea> -->
            </div>
        </div>
        <!-- End Date & Time -->
        <div class="form-group w-100 col-sm-12">
            <label>End Date & Time</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text px-3 py-2">
                        <!-- <img src="../assets/media/icons/png/shift-details/EndDate&Time.png" alt="Client" height="20" /> -->
                        <svg-icon class="svg_icon16x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/end_date_&_time.svg"></svg-icon>
                    </span>
                </div>
                <input type="text" class="form-control"
                    [value]="(shiftDetails.shiftEndDate ? (shiftDetails?.shiftEndDate | TimezoneDateTime) : currentDate)"
                    disabled />
                <!-- <textarea rows="2" class="form-control"
                  disabled>{{ (shiftDetails.shiftEndDate ? (shiftDetails?.shiftEndDate | TimezoneDateTime) : currentDate)}}</textarea> -->
            </div>
        </div>
    </div>

    <ng-container *ngIf="showExtraDetails">



        <div class="row">
            <!-- Rest Break -->
            <div class="form-group w-100 col-sm-6" (click)="restBreakHandler()">
                <label>Rest Break (Paid)</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text px-3 py-2">
                            <!-- <img src="../assets/media/icons/png/shift-details/RestBreak.png" alt="Client" height="20" /> -->
                            <svg-icon class="svg_icon23x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_2/on_break.svg"></svg-icon>
                        </span>
                    </div>
                    <textarea rows="2" class="form-control"
                        disabled>{{shiftDetails.shift_total_paid_break_count}} Rest Break&#10;(Total {{shiftDetails?.shift_total_paid_break_time}} Min)</textarea>
                </div>
            </div>
            <!-- Meal Break -->
            <div class="form-group w-100 col-sm-6" (click)="mealBreakHandler()">
                <label>Meal Break(UnPaid)</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text px-3 py-2">
                            <!-- <img src="../assets/media/icons/png/shift-details/MealBreak.png" alt="Client" height="20" /> -->
                            <svg-icon class="svg_icon23x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/meal_break.svg"></svg-icon>
                        </span>
                    </div>
                    <textarea rows="2" class="form-control"
                        disabled> {{shiftDetails.shift_total_unpaid_break_count}} Meal Break&#10;(Total {{shiftDetails?.shift_total_unpaid_break_time}} Min)</textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- Total Shift Time -->
            <div class="form-group w-100 col-12">
                <label>Total Shift Time</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text px-3 py-2">
                            <!-- <img src="../assets/media/icons/png/shift-details/TotalTime.png" alt="Client" height="20" /> -->
                            <svg-icon class="svg_icon16x20 d-inline " src="assets/media/iq-svg/without_circle/icon_set_1/my_timesheets.svg"></svg-icon>
                        </span>
                    </div>
                    <input type="text" class="form-control"
                        [value]="mathRef.floor((shiftDetails.shift_actual_time/60)) + ' Hours ' + (shiftDetails.shift_actual_time % 60) + ' Minutes'"
                        disabled />
                </div>
            </div>
        </div>

        <div class="card-deck row mx-2">
            <!-- Task -->
            <ng-container *ngxPermissionsOnly="permissionV2.LOCATION_AREA_TASK">
            <div class="card col-3 border-0 form-group mb-3" (click)="openModal(countRef.Task)">
                <label>Task</label>
                <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer w-80">
                    <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
                        <span class="panel-badge">{{shiftAllInfo?.shift_task_group_count}}</span>
                        <!-- <img src="../../../../../../../assets/media/icons/png/shift-details/Task.png" height="" alt=""> -->
                        <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/task.svg"></svg-icon>
                    </div>
                </div>
            </div>
        </ng-container>
            <!-- Form -->
            <ng-container *ngxPermissionsOnly="permissionV2.FORM_MANAGEMENT">
            <div class="card col-3 border-0 form-group mb-3" (click)="openModal(countRef.Form)">
                <label>Form</label>
                <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer w-80">
                    <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
                        <span class="panel-badge">{{shiftAllInfo?.shift_form_count}}</span>
                        <!-- <img src="../../../../../../../assets/media/icons/png/shift-details/Form.png" height="" alt=""> -->
                        <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_1/form_icon.svg"></svg-icon>
                    </div>
                </div>
            </div>
            </ng-container>
            <!-- Loop -->
            <!-- <ng-container *ngxPermissionsOnly="permissionV2.LOOP_PATROL">
            <div class="card col-3 border-0 form-group mb-3" (click)="openModal(countRef.Loop)">
                <label>Loop</label>
                <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer w-80">
                    <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
                        <span class="panel-badge">{{shiftAllInfo?.shift_loop_count}}</span>
                        <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_1/loop_top_icon_(dark_color).svg"></svg-icon>
                    </div>
                </div>
            </div>
            </ng-container> -->
            <!-- patrol -->
            <ng-container *ngxPermissionsOnly="permissionV2.LOOP_PATROL">
            <div class="card col-3 border-0 form-group mb-3" (click)="openModal(countRef.Patrol)">
                <label>Patrol</label>
                <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer w-80">
                    <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
                        <span class="panel-badge">{{shiftAllInfo?.shift_patrol_count}}</span>
                        <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_1/patrolicon.svg"></svg-icon>
                    </div>
                </div>
            </div>
            </ng-container>
            <!-- Reward -->
            <div class="card col-3 border-0 form-group mb-3" (click)="openModal(countRef.Reward)">
                <label>Reward</label>
                <div class="kt-portlet kt-portlet--bordered mb-0 cursor-pointer w-80">
                    <div class="d-flex align-items-center justify-content-center h-100 position-reletive p-3">
                        <span class="panel-badge">{{shiftAllInfo?.shift_reward_count}}</span>
                        <!-- <img src="../../../../../../../assets/media/icons/png/shift-details/Reward.png" height=""
                            alt=""> -->
                            <svg-icon class="svg_icon25x29 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/reward.svg"></svg-icon>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="row">
        <!-- Notes -->
        <div class="form-group w-100 col-12">
            <label>Shift Notes</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text px-3 py-2">
                        <svg-icon class="svg_icon16x20 " src="assets/media/iq-svg/without_circle/icon_set_4/notes.svg"></svg-icon>
                    </span>
                </div>
                <textarea disabled class="form-control" [value]="shiftDetails?.shift_notes || ''"></textarea>
            </div>
        </div>
    </div>
</div>